module.exports = __webpack_public_path__ + "img/detailBg.979026a0.png";